import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options, filterOptions } from "./options"
import { setCompanyActivityType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const CompanyActivityTypeDropdown = ({
  externalDispatch,
  companyRoleType,
  selectedType,
}) => {
  const activeOptions = companyRoleType
    ? options.filter((option) => option.role === companyRoleType)
    : filterOptions
  const [option, setOption] = useOption(companyRoleType, selectedType)
  return (
    <Dropdown
      label="Activity"
      id="company_activity_type_dropdown"
      options={activeOptions}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setCompanyActivityType(option.id))
      }}
    />
  )
}
export default CompanyActivityTypeDropdown
